import React, { FC, useState, MouseEvent, useRef } from "react";
import LabelTag from "./LabelTag";
import CustomPopup from "../Popups/CustomPopup";
import useOnClickOutside from "hooks/useOnClickOutside";

type LabelTagListT = {
  labelIds: string[];
  encryptedMailId: string;
};

const LabelTagList: FC<LabelTagListT> = ({ labelIds, encryptedMailId }) => {
  const [showAllLabels, setShowAllLabels] = useState(false);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setShowAllLabels(false));

  const handleShowAllLabels = (e: MouseEvent) => {
    e.preventDefault();
    setShowAllLabels(true);
  };
  return labelIds?.length ? (
    <div
      className="label-tag-list-wrapper"
      onMouseLeave={() => setShowAllLabels(false)}
      ref={ref}
    >
      {labelIds?.slice(0, 1).map((labelId) => (
        <LabelTag
          id={labelId}
          encryptedMailId={encryptedMailId}
          key={labelId}
        />
      ))}
      {labelIds?.length > 1 && (
        <div onClick={handleShowAllLabels} className="more-labels-button">+{labelIds.length - 1}</div>
      )}
      <CustomPopup showState={showAllLabels} topPosition={20}>
        <div className="all-labels-wrapper">
          {labelIds?.slice(1, labelIds.length).map((labelId) => (
            <LabelTag
              id={labelId}
              encryptedMailId={encryptedMailId}
              key={labelId}
            />
          ))}
        </div>
      </CustomPopup>
    </div>
  ) : (
    <></>
  );
};

export default LabelTagList;
